import React from "react";
import { graphql } from "gatsby";
import slugify from "@sindresorhus/slugify";

const HtmlTextField = ({ data }) => {
  return data?.htmlText ? (
    <>
      {data?.anchorDesktop && data.anchorDesktop && (
        <span id={slugify(data.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <div dangerouslySetInnerHTML={{ __html: data.htmlText }}></div>
    </>
  ) : null;
};

export default HtmlTextField;
export const fragment = graphql`
  fragment HtmlTextFieldFragment on LiferayHtmlTextField {
    id
    liferayFields {
      siteId
      articleId
    }
    anchorDesktop
    anchorMobile
    htmlText
  }
`;
